import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/site";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid={IDS.faqSection}
      className="relative py-24 sm:py-32 bg-cream"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
            Frequently Asked
          </span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-[1.08] tracking-tight text-ink">
            Answers for{" "}
            <span className="font-serif-accent italic font-medium text-brand">
              global buyers.
            </span>
          </h2>
          <p className="mt-4 text-mist">
            Everything you need to know before requesting a quote.
          </p>
        </Reveal>

        <Reveal className="mt-12" delay={0.1}>
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={IDS.faqItem(i)}
                className="border border-line bg-white rounded-2xl px-6 data-[state=open]:shadow-lg data-[state=open]:shadow-forest/5 transition-shadow"
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-base sm:text-lg py-5 hover:no-underline text-ink">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-mist text-sm sm:text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
